import _ from 'lodash';
import React from 'react';
import {default as ReactSelect} from 'react-select';

import classNames from 'classnames';
import selectArrow from './assets/select-arrow.svg';
import closeIcon from 'assets/icons/close-button.svg';

import 'react-select/dist/react-select.css';
import './styles.css';

class SelectOption extends React.Component<any> {
  handleMouseDown = event => {
    /* https://github.com/JedWatson/react-select/blob/master/examples/src/components/CustomComponents.js */

    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    /* https://github.com/JedWatson/react-select/blob/master/examples/src/components/CustomComponents.js */

    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = event => {
    /* https://github.com/JedWatson/react-select/blob/master/examples/src/components/CustomComponents.js */

    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };
  render() {
    return (
      <div
        className={classNames(this.props.className, 'SelectOption')}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}>
        {this.props.children}
      </div>
    );
  }
}

class SelectValue extends React.Component<any> {
  render() {
    return (
      <div className="Select-value" title={this.props.value.title}>
        <span className="Select-value-label">
          <div className="SelectValue" />
          {this.props.children}
        </span>
        {this.props.onRemove && (
          <div
            className="Select-removeElement colab-centered"
            onClick={() => this.props.onRemove(this.props.value)}>
            <img src={closeIcon} alt="Remove Item" />
          </div>
        )}
      </div>
    );
  }
}

const defaultArrowRenderer = () => (
  <div className="arrowRenderer">
    <img src={selectArrow} alt="Select arrow" />
  </div>
);

class Select extends React.Component<any> {
  state = {
    selectedOption: null
  };

  changeOption = option => this.setState({selectedOption: option});

  static TOP = 'top';

  render() {
    const {
      dark,
      simpleValue,
      multi,
      value,
      options,
      onChange,
      onBlur,
      disabled,
      placeholder,
      clearable,
      menuPosition,
      searchable,
      closeOnSelect,
      className
    } = this.props;

    return (
      <div
        className={classNames('Select', className, {
          dark,
          above: menuPosition === Select.TOP
        })}>
        <ReactSelect
          searchable={searchable || false}
          clearable={_.isNil(clearable) ? true : clearable}
          deleteRemoves={_.isNil(clearable) ? true : clearable}
          arrowRenderer={this.props.arrowRenderer || defaultArrowRenderer}
          value={_.isNil(value) ? this.state.selectedOption : value}
          options={options}
          onChange={onChange || this.changeOption}
          onBlur={onBlur}
          disabled={disabled}
          className="ReactSelect"
          optionComponent={SelectOption}
          valueComponent={SelectValue}
          placeholder={placeholder}
          multi={multi || false}
          closeOnSelect={_.isNil(closeOnSelect) ? true : false}
          simpleValue={simpleValue || false}
        />
      </div>
    );
  }
}

export default Select;
